import './OurTechnologies.scss';

class OurTechnologies {

  constructor(node) {
    this.node = node;
  }

  init() {
    //console.log();
  }

}

JSModules['OurTechnologies'] = OurTechnologies;
export default OurTechnologies;
